<template>
  <rect width="38" height="48" rx="3" fill="currentColor" />
  <rect x="40" y="1" width="10" height="10" rx="2" fill="currentColor" />
  <rect x="40" y="13" width="10" height="10" rx="2" fill="currentColor" />
  <rect x="40" y="25" width="10" height="10" rx="2" fill="currentColor" />
  <rect x="40" y="37" width="10" height="10" rx="2" fill="currentColor" />
</template>
